import React, { Fragment, useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { query, searchFacetChange, setFilterTabOpen } from '../Actions/FacetedSearch.action';
import { Svg } from './Svg';

const FacetedSearchGroup = ({ group }) => {
    const list = useRef(null);
    const listTop = useRef(null);
    const firstRender = useRef(true);

    const expandFilters = useCallback((group) => {
        group.expanded = !group.expanded;
        var domGroup = document.getElementById(group.id);
        if (group.expanded) {
            domGroup.classList.add("expanded");
        } else {
            domGroup.classList.remove("expanded");
        }
    }, []);

    useEffect(() => {
        // Make sure it is executed only once.
        // firstRender is used to prevent eslint warning when having empty dependencies array
        if (!firstRender.current) {
            return;
        }
        firstRender.current = false;
    }, [group]);

    const chevronClass = group.expanded ? "chevron-up" : "chevron-down";

    return (
        <Fragment>
            <ul id={group.id} className={`faceted-search__group ${group.expanded ? "expanded" : ""}`} role="group" ref={list}>
                <div className="faceted-search__group-header-row" onClick={() => expandFilters(group)}>
                    <div className="faceted-search__group-header">
                        {group.label}
                    </div>
                    <span className="faceted-search__group-header__arrow">
                        <Svg icon="chevron" extraClass={chevronClass}/>
                    </span>
                </div>
                
                {group.options &&
                    group.options.map((item, itemIndex, array) => (
                        <li
                            key={`${item.label}-${itemIndex}`}
                            className="faceted-search__item"
                            role="menuitemcheckbox"
                        >
                            <FacetedFilterCheckbox item={item} group={group} />
                        </li>
                    ))}
            </ul>
        </Fragment>
    );
};

const FacetedFilterCheckbox = ({ item, group }) => {
    const dispatch = useDispatch();
    const onChange = useCallback(
        (group, item) => dispatch(searchFacetChange(group, item)),
        [dispatch]
    );
    return (
        <label className="faceted-filter">
             <span className="faceted-filter__label" title={item.label}>
                {item.label}
                {!isNaN(item.quantity) && item.quantity != null && group.id !== "ProducerName" && (
                    <span className="faceted-filter__quantity">
                        &nbsp;({item.quantity})
                    </span>
                )}
            </span>
            
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={(event) => onChange(group, item)}
                id={item.id}
                checked={
                    group.selectedOptions != null &&
                    group.selectedOptions.includes(item.id)
                }
            />

            <label className="faceted-filter__virtual-checkbox" htmlFor={item.id}></label>
        </label>
    );
};

const FacetedSearch = () => {
    const dispatch = useDispatch();
    const { facetFilters, navigationTheme, filterTabOpen } = useSelector(
        (state) => state.facetedSearch
    );

    let statusClass = filterTabOpen ? "" : "hide-filter closed";

    useEffect(() => {
        // listen to history events (back, forward) of window
        window.onpopstate =
            window.onpopstate ||
            ((event) => {
                dispatch(query(window.location.search.substr(1) || ''));
            });
    }, [dispatch]);

    return (
        navigationTheme !== 'category' &&
        facetFilters &&
        facetFilters.length > 0 && (
            <aside id="product-filter" className={`columns product-filtering subnav-filter ${statusClass}`}>
                <div className="faceted-search" role="menu">
                    <div className="faceted-search__top-menu">
                        <div className="faceted-search__top-menu__header">
                            <Svg icon="filter" extraClass="category-page__filter-section__menu"/>
                            {translate('nmas.category.filter')}
                        </div>
                        <button id="close-filter" onClick={() => dispatch(setFilterTabOpen(false))} className="close-filter-button">
                            <Svg icon="close"/>
                        </button>
                    </div>

                    {facetFilters.map((group, groupIndex) => (
                        <FacetedSearchGroup
                            key={`${group.label}-${groupIndex}`}
                            group={group}
                        />
                    ))}
                </div>
            </aside>
        )
    );
};

export default FacetedSearch;
